import { ApplicationData } from "../ls2pac/ApplicationData";
import { LibraryThing } from "../ls2pac/widget/LibraryThingWidget";

export class KidsAddCoverArt {
	constructor() { }
	static load($container, options) {
		options = $.extend({}, KidsAddCoverArt._defaultOptions, options);

		var resource = options.resources[options.index];

		var bookjacketUrl = LibraryThing.getBookjacketUrl(options.requestType, resource);

		//Determine parents positioning.  Set to relative if not relative or absolute;
		var pos = $container.css('position');

		if (pos != 'relative' && pos != 'absolute') {
			$container.css('position', 'relative');
		}

		// NOTES:
		// .data() does not work
		// should we update this to .attr('data-<data-attr>')?
		// https://stackoverflow.com/a/8708345
		$container.data('image-alt', resource.shortTitle);

		$container.data('requestType', options.requestType);
		$container.data('callback', options.callback);

		$container.one('error', function () {
			$container.data("loadError", true);
		});

		KidsAddCoverArt.showDummy(options, $container, resource);
		if (bookjacketUrl) {
			KidsAddCoverArt.loadJacket(options, $container, resource, bookjacketUrl);
		}
	}
	static loadJacket(options, $container, resource, bookjacketUrl) {
		var image = new Image();

		$(image).one('load', function (event) {
			KidsAddCoverArt.checkImage(options, image, $container, resource);
			$(event.currentTarget).attr('alt', resource.shortTitle);
		});

		$container.data("isLoading", true);

		image.src = bookjacketUrl;
	}
	static getRandomColor(options) {
		var colors = options.colors;
		if (colors.length == 1) {
			return colors[0];
		}

		var nextColor = null;

		while (nextColor == null || KidsAddCoverArt.getRandomColor._lastColor == nextColor) {
			nextColor = colors[Math.floor(Math.random() * colors.length)];
		}

		KidsAddCoverArt.getRandomColor._lastColor = nextColor;

		return nextColor;
	}
	static checkImage(options, image, $container, resource) {
		var $image = $(image);
		var width = $image.get(0).width;
		var height = $image.get(0).height;

		$image.attr('alt', resource.shortTitle);
		$container
			.data('original-width', width)
			.data('original-height', height);

		if (width <= 2 || height <= 2) {
			$container.data('blank-jacket-loaded', true);


			KidsAddCoverArt.showDummy(options, $container, resource);
		} else {
			var imgClass = options.requestType.toLowerCase();

			$container
				.removeClass($container.data("dummyClass"))
				.empty()
				.append($image)
				.addClass(imgClass)
				.addClass('bookjacket')
				.data('real-jacket-loaded', true)
				.show();

			var callback = $container.data('callback');

			if (typeof callback === "function") {
				callback(false);
			}
		}
	}
	static showDummy(options, $container, resource) {
		if ($container.data('dummy-jacket-loading') ||
			$container.data('real-jacket-loaded') ||
			($container.data('blank-jacket-loaded') && $container.data('dummy-jacket-loaded'))) {
			return;
		}

		function finished() {
			var callback = $container.data('callback');

			if (typeof callback === "function") {
				callback(true);
			}
		}

		if (options.displayDummyJacket && ApplicationData.locationConfiguration.getUseDummyJackets()) {
			$container.data('dummy-jacket-loading', true);

			var randomColor = KidsAddCoverArt.getRandomColor(options);

			var dummyJacketUrl = "images/bookjackets/randos/" + randomColor + "-" + options.requestType.toLowerCase() + ".png";

			var dummyImage = new Image();

			var imageClass = options.requestType.toLowerCase();

			$(dummyImage).one('load', function (event) {
				$container.data('dummy-jacket-loading', false);

				if (!$container.data("real-jacket-loaded")) {
					$container.data("dummy-jacket-loaded", true);
					$container.data('dummy-jacket', true);

					// NOTE:
					// * removing this will prevent the duplicate alt text warning
					// we need to verify it does not change the behavior of other pages
					var $bookTitle = $('<div class="bookjacket-title">' + resource.shortTitle + '</div>');
					// * we can also use aria-labelledby
					// https://www.w3.org/WAI/GL/wiki/Using_aria-labelledby_to_provide_a_text_alternative_for_non-text_content
					$container
						.addClass("bookjacket")
						.addClass("dummy-" + imageClass)
						.addClass(imageClass)
						.data("dummyClass", "dummy-" + imageClass)
						.append(dummyImage)
						.append($bookTitle);

					finished();
				}
				$(event.currentTarget).attr('alt', resource.shortTitle + ' cover');
			});

			dummyImage.src = dummyJacketUrl;
		} else {
			finished();
		}
	}
}

KidsAddCoverArt._lastColor = null;

KidsAddCoverArt._defaultOptions = {
	requestType:        LibraryThing.enums.requestType.bookJacketSmall,
	resources:          null,
	index:              -1,
	displayDummyJacket: true,
	callback:           null,
	colors:             ["green", "orange", "purple", "red", "gray"]
};






